import { render } from "./S272475Legal.vue?vue&type=template&id=926655a8"
const script = {}
script.render = render

export default script